import { z } from 'zod'
import { latLngSchema, poiCategorySchema } from './common.schemas.js'

export const suggestPOIsSchema = z.object({
  location: latLngSchema,
  categories: z.array(poiCategorySchema).min(1).max(8),
  radiusKm: z.number().min(5).max(150).default(25),
  preferences: z.object({
    prompt: z.string().max(500).optional(),
    avoidHighways: z.boolean().optional(),
    preferScenic: z.boolean().optional(),
    language: z.string().max(8).optional()
  }).optional(),
  context: z.object({
    fromPoint: latLngSchema.extend({ name: z.string().optional() }).optional(),
    toPoint: latLngSchema.extend({ name: z.string().optional() }).optional(),
    detourMaxKm: z.number().min(0).max(100).optional(),
    timeAvailable: z.number().min(0).optional()
  }).optional(),
  planId: z.string().optional(),
  stageId: z.string().optional(),
  planName: z.string().optional(),
  stageName: z.string().optional()
})

export const enhancePlanSchema = z.object({
  planId: z.string().uuid()
})

export const dashboardSuggestionSchema = z.object({
  planId: z.string().uuid(),
  context: z.enum(['pre', 'during', 'spark']),
  anchorStageId: z.string().uuid().optional(),
  categories: z.array(poiCategorySchema).min(1).max(6).optional(),
  radiusKm: z.number().min(5).max(120).optional()
})
